<template>
  <div>
    <div class="w-full pt-20">
      <div class="container mx-auto pl-20 pr-10">
        <div class="text-left text-sm text-gray-62 mt-10">
          <div class="flex">
            <span class="pt-1 mr-2"><img src="@/assets/icons/Back.svg" /></span
            ><router-link :to="{ name: 'Top' }"
              >サービス情報一覧へ戻る</router-link
            >
          </div>
        </div>
        <div>
          <div class="flex">
            <CompNav
              :hasPublished="hasPublished"
              @show-modal="
                companyDetail =
                  $event == 'preview' ? getPreviewData() : publicData;
                showModal = true;
              "
            ></CompNav>
            <div class="flex-1 icj-change-display-company">
              <h2 class="text-2xl font-semibold text-gray-92 leading-8 mb-4">
                企業情報
              </h2>
              <div class="text-gray-92">
                アンケート回答に関するご不明点はお気軽に画面右下のチャットボットよりお問い合わせください。担当者がサポートいたします。
              </div>
              <div class="mt-4">
                <div id="profile">
                  <div
                    class="mb-8 py-12 pl-20 bg-white rounded"
                    style="padding-right: 12.5rem"
                  >
                    <div class="flex items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        プロフィール
                      </h3>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <template v-for="form in formDataCompanyGroups.profile">
                        <div
                          :key="form.id"
                          :id="'target' + form.id"
                          :class="{
                            'col-span-2': !form.input_position,
                            'col-span-1': form.input_position,
                            'col-start-1': form.input_position == 'left',
                            'col-end-1': form.input_position == 'left',
                            'col-start-2': form.input_position == 'right',
                            'col-end-2': form.input_position == 'right',
                          }"
                          v-if="
                            notShows['.icj-change-display-company']
                              ? !notShows['.icj-change-display-company'][
                                  form.id
                                ]
                              : true
                          "
                          style="position: relative"
                        >
                          <CompFormParts
                            :inputData="inputDataCompany"
                            :form="form"
                            :publishRequestedExists="publishRequestedExists"
                            :isSubmit="isSubmit"
                          ></CompFormParts>
                        </div>
                      </template>
                    </div>
                    <div>
                      <div class="relative">
                        <div
                          class="errorDiv"
                          :class="{
                            'icj-required': true,
                            'icj-required-valid': pdfFile.url || pdfFile.data,
                            'icj-error': !pdfFile.url && !pdfFile.data,
                          }"
                          id="pdfFile"
                        ></div>
                        <div
                          class="block p-5"
                          :class="{
                            'mb-5 bg-coral-light': errorMessages.pdfFile,
                          }"
                        >
                          <div class="flex items-center mb-5 font-semibold">
                            <h4 class="text-gray-92 text-sm">企業紹介資料</h4>
                            <span
                              class="ml-2"
                              style="color: #de2d2d; font-size: 11px"
                              >必須</span
                            >
                          </div>
                          <div class="flex">
                            <div>
                              <div
                                class="mr-2 text-sm font-light text-gray-92 leading-6 mb-2"
                                style="width: 24rem"
                              >
                                企業案内パンフレットなど、企業のプロフィールや事業内容が確認できる資料を用意しましょう。
                              </div>
                              <div
                                class="bg-slate-100 py-1 text-center text-xs px-5 rounded-full text-gray-92 mb-6 inline-block"
                              >
                                ファイル形式：<span class="font-light"
                                  >pdf (20MB以下) 枚数制限なし</span
                                >
                              </div>
                              <div class="flex">
                                <div>
                                  <label
                                    for="company_upload_pdf"
                                    class="inline-block text-white text-sm rounded font-semibold px-10 py-3 mb-2 cursor-pointer text-center leading-none font-semibold"
                                    :class="[
                                      publishRequestedExists
                                        ? 'bg-gray-32'
                                        : 'bg-secondary-main',
                                    ]"
                                  >
                                    資料をアップロード
                                  </label>
                                  <input
                                    id="company_upload_pdf"
                                    name="company_upload_pdf"
                                    type="file"
                                    accept="application/pdf"
                                    @change.prevent="selectedPdfFile($event)"
                                    style="display: none"
                                    :disabled="publishRequestedExists"
                                  />
                                  <div
                                    v-if="errorMessages.pdfFile"
                                    class="text-danger text-sm"
                                  >
                                    {{ errorMessages.pdfFile }}
                                  </div>
                                </div>
                                <div v-if="pdfFile.url">
                                  <a
                                    :href="pdfFile.url"
                                    target="_blank"
                                    class="flex ml-2 pt-4"
                                  >
                                    <div
                                      class="ic-text-red ic-border-bottom-red"
                                    >
                                      資料を確認
                                    </div>
                                    <div class="ml-1 pt-1">
                                      <img
                                        src="@/assets/icons/ExternaLlinkRed.svg"
                                      />
                                    </div>
                                  </a>
                                </div>
                                <div v-if="pdfFile.data" class="flex ml-2 pt-4">
                                  <div class="ic-text-red text-sm">
                                    {{ pdfFile.name }}
                                  </div>
                                </div>
                                <div
                                  v-if="
                                    (pdfFile.url || pdfFile.data) &&
                                    !publishRequestedExists
                                  "
                                >
                                  <div
                                    class="flex ml-2 pt-4 cursor-pointer"
                                    @click="
                                      (pdfFile.data = ''), (pdfFile.url = '')
                                    "
                                  >
                                    <div class="text-gray-92 border-b">
                                      資料を削除
                                    </div>
                                    <div
                                      class="ml-1 pt-1"
                                      style="width: 14px; height: 14px"
                                    >
                                      <img src="@/assets/icons/Trash.svg" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div id="summary">
                  <div
                    class="mb-8 py-12 pl-20 bg-white rounded"
                    style="padding-right: 12.5rem"
                  >
                    <div class="flex items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        企業概要
                      </h3>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <template v-for="form in formDataCompanyGroups.summary">
                        <div
                          :key="form.id"
                          :id="'target' + form.id"
                          :class="{
                            'col-span-2': !form.input_position,
                            'col-span-1': form.input_position,
                            'col-start-1': form.input_position == 'left',
                            'col-end-1': form.input_position == 'left',
                            'col-start-2': form.input_position == 'right',
                            'col-end-2': form.input_position == 'right',
                          }"
                          v-if="
                            notShows['.icj-change-display-company']
                              ? !notShows['.icj-change-display-company'][
                                  form.id
                                ]
                              : true
                          "
                          style="position: relative"
                        >
                          <CompFormParts
                            :inputData="inputDataCompany"
                            :form="form"
                            :publishRequestedExists="publishRequestedExists"
                            :isSubmit="isSubmit"
                          ></CompFormParts>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div id="management">
                  <div
                    class="mb-8 py-12 pl-20 bg-white rounded"
                    style="padding-right: 12.5rem"
                  >
                    <div class="flex items-center">
                      <h3
                        class="text-xl leading-7 font-semibold text-gray-92 mb-5"
                      >
                        経営データ
                      </h3>
                    </div>
                    <div class="grid grid-cols-2 gap-4">
                      <template
                        v-for="form in formDataCompanyGroups.management"
                      >
                        <div
                          :key="form.id"
                          :id="'target' + form.id"
                          :class="{
                            'col-span-2': !form.input_position,
                            'col-span-1': form.input_position,
                            'col-start-1': form.input_position == 'left',
                            'col-end-1': form.input_position == 'left',
                            'col-start-2': form.input_position == 'right',
                            'col-end-2': form.input_position == 'right',
                          }"
                          v-if="
                            notShows['.icj-change-display-company']
                              ? !notShows['.icj-change-display-company'][
                                  form.id
                                ]
                              : true
                          "
                          style="position: relative"
                        >
                          <CompFormParts
                            :inputData="inputDataCompany"
                            :form="form"
                            :publishRequestedExists="publishRequestedExists"
                            :isSubmit="isSubmit"
                          ></CompFormParts>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <div id="location">
                  <div
                    class="mb-8 py-12 pl-20 bg-white rounded"
                    style="padding-right: 12.5rem"
                  >
                    <div class="flex items-center">
                      <h3
                        class="text-xl leading-8 font-semibold text-gray-92 mb-10"
                      >
                        企業所在地
                      </h3>
                    </div>
                    <div class="mb-10">
                      <div
                        class="text-gray-92 mb-4 text-sm leading-4 font-semibold"
                      >
                        本社の所在地<span
                          class="ml-2"
                          style="color: #de2d2d; font-size: 11px"
                          >必須</span
                        >
                      </div>
                      <div class="bg-slate-50 relative" style="width: 40rem">
                        <div class="px-4 py-4">
                          <div class="flex relative">
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error.inputDataHeadOfficeZipCode,
                                'icj-error': error.inputDataHeadOfficeZipCode,
                              }"
                              id="headOfficeZipCode"
                            ></div>
                            <div
                              class="flex-1 p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages.inputDataHeadOfficeZipCode,
                              }"
                            >
                              <div class="flex justify-between mb-3">
                                <div
                                  class="text-gray-92 text-sm leading-4 font-semibold"
                                >
                                  郵便番号
                                </div>
                                <div class="text-gray-62 text-xs leading-4">
                                  半角数字
                                </div>
                              </div>
                              <div>
                                <input
                                  type="text"
                                  name="inputDataHeadOfficeZipCode"
                                  class="block min-w-full px-4 py-3 font-light border rounded leading-4"
                                  :class="[
                                    errorMessages.inputDataHeadOfficeZipCode
                                      ? 'border-danger'
                                      : 'border-gray-38',
                                  ]"
                                  placeholder="000-0000"
                                  v-model="inputDataHeadOffice.zip_code"
                                  @input="inputValidate($event, 'required|zip')"
                                  :disabled="publishRequestedExists"
                                />
                                <div
                                  v-if="
                                    errorMessages.inputDataHeadOfficeZipCode
                                  "
                                  class="text-danger text-sm mt-2"
                                >
                                  {{ errorMessages.inputDataHeadOfficeZipCode }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error.inputDataHeadOfficePrefecture,
                                'icj-error':
                                  error.inputDataHeadOfficePrefecture,
                              }"
                              id="headOfficePrefecture"
                            ></div>
                            <div
                              class="flex-1 p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages.inputDataHeadOfficePrefecture,
                              }"
                            >
                              <div class="flex justify-between mb-3">
                                <div
                                  class="text-gray-92 text-sm leading-4 font-semibold"
                                >
                                  都道府県
                                </div>
                              </div>
                              <div>
                                <select
                                  name="inputDataHeadOfficePrefecture"
                                  class="w-full text-gray-92 text-sm leading-4 font-light block font-light border rounded px-2 py-2"
                                  :class="{
                                    'border-danger':
                                      errorMessages.inputDataHeadOfficePrefecture,
                                    'border-gray-38':
                                      !errorMessages.inputDataHeadOfficePrefecture,
                                    'bg-disabled': publishRequestedExists,
                                  }"
                                  v-model="inputDataHeadOffice.prefecture"
                                  @change="inputValidate($event, 'required')"
                                  :disabled="publishRequestedExists"
                                >
                                  <option value="">選択してください</option>
                                  <option
                                    v-for="pref in prefs"
                                    :key="pref.id"
                                    :value="pref.id"
                                  >
                                    {{ pref.name }}
                                  </option>
                                </select>
                                <div
                                  v-if="
                                    errorMessages.inputDataHeadOfficePrefecture
                                  "
                                  class="text-danger text-sm mt-2"
                                >
                                  {{
                                    errorMessages.inputDataHeadOfficePrefecture
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="relative">
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error.inputDataHeadOfficeAddress,
                                'icj-error': error.inputDataHeadOfficeAddress,
                              }"
                              id="headOfficeAddress"
                            ></div>
                            <div
                              class="p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages.inputDataHeadOfficeAddress,
                              }"
                            >
                              <input
                                type="text"
                                name="inputDataHeadOfficeAddress"
                                class="block min-w-full px-4 py-3 font-light border rounded leading-4"
                                :class="[
                                  errorMessages.inputDataHeadOfficeAddress
                                    ? 'border-danger'
                                    : 'border-gray-38',
                                ]"
                                placeholder="都道府県以降の住所"
                                v-model="inputDataHeadOffice.address"
                                @input="inputValidate($event, 'required')"
                                :disabled="publishRequestedExists"
                              />
                              <div
                                v-if="errorMessages.inputDataHeadOfficeAddress"
                                class="text-danger text-sm mt-2"
                              >
                                {{ errorMessages.inputDataHeadOfficeAddress }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="margin-bottom: 2.25rem">
                      <div
                        class="text-gray-92 mb-2 text-sm leading-4 font-semibold"
                      >
                        本社以外の国内外の事業所数<span
                          class="ml-2"
                          style="color: #de2d2d; font-size: 11px"
                          >必須</span
                        >
                      </div>
                      <div>
                        <input
                          type="text"
                          name="branchCount"
                          class="block min-w-full px-4 py-3 font-light border rounded leading-4"
                          :class="{
                            'border-danger': errorMessages.branchCount,
                            'icj-required': true,
                            'icj-required-valid': !error.branchCount,
                            'icj-error': error.branchCount,
                          }"
                          v-model="branchCount"
                          @blur="changeBranchCount()"
                          @input="inputValidate($event, 'required')"
                          :disabled="publishRequestedExists"
                        />
                        <div
                          v-if="errorMessages.branchCount"
                          class="text-danger text-sm mt-2"
                        >
                          {{ errorMessages.branchCount }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="(inputDataBranch, index) in inputDataBranches"
                      :key="index"
                      class="mb-10"
                    >
                      <div
                        v-if="inputDataBranches.length == index + 1"
                        id="last_branch"
                      ></div>
                      <div
                        class="text-gray-92 mb-4 text-sm leading-4 font-semibold"
                      >
                        支社の所在地<span
                          class="ml-2"
                          style="color: #de2d2d; font-size: 11px"
                          >必須</span
                        >
                      </div>
                      <div
                        class="bg-slate-50 relative"
                        style="width: 40rem"
                        @mouseover="hoverDeleteButtons[index] = true"
                        @mouseleave="hoverDeleteButtons[index] = false"
                      >
                        <div
                          v-if="!publishRequestedExists"
                          v-show="hoverDeleteButtons[index]"
                          class="absolute"
                          style="top: -1rem; right: 2.5rem"
                        >
                          <button
                            class="bg-white rounded w-8 h-8 flex justify-center items-center focus:outline-none"
                            style="
                              box-shadow: 0px 0px 4px rgba(152, 163, 190, 0.6);
                            "
                            @click="deleteInputDataBranch(index)"
                          >
                            <img src="@/assets/icons/Trash.svg" />
                          </button>
                        </div>
                        <div class="px-4 py-4">
                          <div class="flex relative">
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error['inputDataBranchZipCode' + index],
                                'icj-error':
                                  error['inputDataBranchZipCode' + index],
                              }"
                              :id="'branchZipCode' + index"
                            ></div>
                            <div
                              class="flex-1 p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages[
                                    'inputDataBranchZipCode' + index
                                  ],
                              }"
                            >
                              <div class="flex justify-between mb-3">
                                <div
                                  class="text-gray-92 text-sm leading-4 font-semibold"
                                >
                                  郵便番号
                                </div>
                                <div class="text-gray-62 text-xs leading-4">
                                  半角数字
                                </div>
                              </div>
                              <div>
                                <input
                                  type="text"
                                  :name="'inputDataBranchZipCode' + index"
                                  class="block min-w-full px-4 py-3 font-light border rounded leading-4"
                                  :class="[
                                    errorMessages[
                                      'inputDataBranchZipCode' + index
                                    ]
                                      ? 'border-danger'
                                      : 'border-gray-38',
                                  ]"
                                  placeholder="000-0000"
                                  v-model="inputDataBranch.zip_code"
                                  @input="inputValidate($event, 'required|zip')"
                                  :disabled="publishRequestedExists"
                                />
                                <div
                                  v-if="
                                    errorMessages[
                                      'inputDataBranchZipCode' + index
                                    ]
                                  "
                                  class="text-danger text-sm mt-2"
                                >
                                  {{
                                    errorMessages[
                                      'inputDataBranchZipCode' + index
                                    ]
                                  }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error['inputDataBranchPrefecture' + index],
                                'icj-error':
                                  error['inputDataBranchPrefecture' + index],
                              }"
                              :id="'branchPrefecture' + index"
                            ></div>
                            <div
                              class="flex-1 p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages[
                                    'inputDataBranchPrefecture' + index
                                  ],
                              }"
                            >
                              <div class="flex justify-between mb-3">
                                <div
                                  class="text-gray-92 text-sm leading-4 font-semibold"
                                >
                                  都道府県
                                </div>
                              </div>
                              <div>
                                <select
                                  :name="'inputDataBranchPrefecture' + index"
                                  class="w-full text-gray-92 text-sm leading-4 font-light block font-light border rounded px-2 py-2"
                                  :class="{
                                    'border-danger':
                                      errorMessages[
                                        'inputDataBranchPrefecture' + index
                                      ],
                                    'border-gray-38':
                                      !errorMessages[
                                        'inputDataBranchPrefecture' + index
                                      ],
                                    'bg-disabled': publishRequestedExists,
                                  }"
                                  v-model="inputDataBranch.prefecture"
                                  @change="inputValidate($event, 'required')"
                                  :disabled="publishRequestedExists"
                                >
                                  <option value="">選択してください</option>
                                  <option
                                    v-for="pref in prefs"
                                    :key="pref.id"
                                    :value="pref.id"
                                  >
                                    {{ pref.name }}
                                  </option>
                                </select>
                                <div
                                  v-if="
                                    errorMessages[
                                      'inputDataBranchPrefecture' + index
                                    ]
                                  "
                                  class="text-danger text-sm mt-2"
                                >
                                  {{
                                    errorMessages[
                                      'inputDataBranchPrefecture' + index
                                    ]
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="relative">
                            <div
                              class="errorDiv"
                              :class="{
                                'icj-required': true,
                                'icj-required-valid':
                                  !error['inputDataBranchAddress' + index],
                                'icj-error':
                                  error['inputDataBranchAddress' + index],
                              }"
                              :id="'branchAddress' + index"
                            ></div>
                            <div
                              class="p-4"
                              :class="{
                                'mb-5 bg-coral-light':
                                  errorMessages[
                                    'inputDataBranchAddress' + index
                                  ],
                              }"
                            >
                              <input
                                type="text"
                                :name="'inputDataBranchAddress' + index"
                                class="block min-w-full px-4 py-3 font-light border rounded leading-4"
                                :class="[
                                  errorMessages[
                                    'inputDataBranchAddress' + index
                                  ]
                                    ? 'border-danger'
                                    : 'border-gray-38',
                                ]"
                                placeholder="都道府県以降の住所"
                                v-model="inputDataBranch.address"
                                @input="inputValidate($event, 'required')"
                                :disabled="publishRequestedExists"
                              />
                              <div
                                v-if="
                                  errorMessages[
                                    'inputDataBranchAddress' + index
                                  ]
                                "
                                class="text-danger text-sm mt-2"
                              >
                                {{
                                  errorMessages[
                                    'inputDataBranchAddress' + index
                                  ]
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-show="!publishRequestedExists" class="text-right">
                      <button
                        class="ml-auto rounded-full py-2 pl-8 text-gray-92 border text-xs focus:outline-none flex items-center"
                        style="padding-right: 1.75rem"
                        @click="addInputDataBranch()"
                        :disabled="publishRequestedExists"
                      >
                        <div
                          class="company_location_icon"
                          style="margin-right: 0.375rem"
                        >
                          <img
                            src="@/assets/icons/Plus.svg"
                            style="width: 12px; height: auto"
                          />
                        </div>
                        <div class="font-semibold">事業所を追加</div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white sticky bottom-0 border-t border-gray-12">
        <div class="container mx-auto relative">
          <div class="flex justify-between items-center">
            <div class="ml-24">
              <template v-if="requiredCount > 0">
                <span
                  v-if="requiredCount - requiredValidCount > 0"
                  class="mr-4 text-gray-92"
                >
                  <span class="text-sm">あと</span>
                  <span class="font-semibold text-4xl mx-1">{{
                    requiredCount - requiredValidCount
                  }}</span>
                  <span class="text-sm">件の必須項目が残っています</span>
                </span>
                <span
                  v-else-if="publishRequestedExists"
                  class="mr-4 text-gray-92"
                >
                  <span class="text-sm"
                    >現在公開申請中のため、編集できません
                  </span>
                </span>
                <span v-else class="mr-4 text-gray-92">
                  <span class="text-sm font-semibold"
                    >必須項目はすべて入力されています</span
                  >
                </span>
              </template>
              <transition name="fade-in-out">
                <span
                  v-show="footerMessageFlag"
                  class="text-sm service_deep_gray font-semibold"
                  style="color: #de2d2d"
                  >一時保存しました</span
                >
              </transition>
            </div>
            <div class="flex justify-end relative">
              <button
                class="text-base font-semibold py-5 px-12 h-16 focus:outline-none"
                :class="{
                  'text-gray-92': !publishRequestedExists,
                  'text-gray-32': publishRequestedExists,
                  'cursor-not-allowed': publishRequestedExists,
                  'hover:button': !publishRequestedExists,
                }"
                :disabled="publishRequestedExists || isSaving"
                @click="isDraftedDisplay || update()"
              >
                下書きに保存
              </button>
              <button
                v-if="!hasPublished"
                class="text-white text-base font-semibold py-5 px-12 h-16 focus:outline-none"
                :class="{
                  'ic-bg-red': !publishRequestedExists,
                  'bg-gray-32': publishRequestedExists,
                  'hover:bg-blue-100': !publishRequestedExists,
                  'cursor-not-allowed': publishRequestedExists,
                  'hover:button': !publishRequestedExists,
                }"
                :disabled="publishRequestedExists || isSubmitted"
                @click="isDraftedDisplay || update('publish')"
              >
                この内容で公開申請
              </button>
              <button
                v-else
                class="ic-bg-red text-white text-base font-semibold py-5 px-12 h-16 hover:bg-blue-100 hover:button focus:outline-none"
                @click="isDraftedDisplay || update('autoPublish')"
              >
                内容を更新する
              </button>
            </div>
          </div>
        </div>
      </div>

      <ModalRight
        :showModal="showModal"
        :modalOpacity="modalOpacity"
        @close-modal="showModal = false"
      >
        <ServiceCompanyDetail
          viewMode="company"
          :companyDetail="companyDetail"
          @close-modal="showModal = false"
        />
      </ModalRight>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs, watch, inject, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import axios from '@/utils/axiosAuth.js';
import utils from '@/utils/utils';
import changeDisplayed from '@/utils/change-displayed';
import areas from '@/utils/areas';
import CompNav from '@/views/company/vue/CompNav';
import CompFormParts from '@/views/company/vue/CompFormParts';
import ModalRight from '@/components/modalRight/modalRight.vue';
import ServiceCompanyDetail from '@/components/modalRight/service/ServiceCompanyDetail.vue';
import validateRules from '@/utils/validateRules.js';

export default {
  components: {
    CompNav,
    CompFormParts,
    ModalRight,
    ServiceCompanyDetail,
  },
  setup() {
    const globalMethods = inject('globalMethods');
    const route = useRoute();
    const { runDisplayed, notShows } = changeDisplayed();

    const state = reactive({
      isSaving: false, // 下書きに保存
      isSubmitted: false,

      isDraftedDisplay: 0,

      companyId: null,

      valid: false,
      isSubmit: false,

      prefs: [],

      footerMessageFlag: false,
      publishRequestedExists: 0,
      is_credit_tdb: 0,
      is_credit_tsr: 0,
      is_credit_rm: 0,

      // form構造データ
      formDataCompany: {},
      formDataCompanyGroups: {
        // group分割用
        profile: [],
        summary: [],
        management: [],
      },

      // 入力データ
      inputDataCompany: {},

      // 状態 drafted or published
      status: '',

      // 企業情報用PDFファイル
      pdfFile: {
        name: '',
        data: '',
        url: '',
      },

      // watch用 Timer
      timer: null,

      // 本社
      inputDataHeadOffice: {
        id: null,
        type: 'head',
        zip_code: '',
        prefecture: '',
        address: '',
      },

      // 支社
      branchCount: 0,
      inputDataBranches: [],
      initInputDataBranch: {
        type: 'branch',
        zip_code: '',
        prefecture: '',
        address: '',
      },

      error: {},
      errorMessages: {
        pdfFile: '',
      },

      requiredCount: 0,
      requiredValidCount: 0,

      showModal: false,
      modalOpacity: true,
      publicData: {},
      companyDetail: {},

      hasPublished: false,

      hoverShow: false,

      hoverDeleteButtons: [],
    });

    // --------------------------------------------------------
    //  add, delete, change, selected
    // --------------------------------------------------------
    const addInputDataBranch = () => {
      state.inputDataBranches.push({ ...state.initInputDataBranch, id: null });
      state.branchCount = state.inputDataBranches.length;
      validateCompanyLocations(false);
    };
    const deleteInputDataBranch = (index) => {
      state.inputDataBranches.splice(index, 1);
      state.branchCount = state.inputDataBranches.length;
      validateCompanyLocations(false);
    };
    const deleteInputDataImage = () => {};
    const changeBranchCount = () => {
      const diff = state.branchCount - state.inputDataBranches.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i++) {
          addInputDataBranch();
        }
      } else if (diff < 0) {
        for (let i = 0; i > diff; i--) {
          state.inputDataBranches.pop();
        }
      }
    };
    const fileError = (name, message) => {
      state[name] = {
        name: '',
        data: '',
        url: '',
      };
      state.errorMessages[name] = message;
      countingRequired();
    };

    const selectedPdfFile = async (e = null) => {
      if (e === null) {
        if (!state.pdfFile.data && !state.pdfFile.url) {
          fileError('pdfFile', '必須項目です');
        }
        return;
      }
      const files = e.target.files;
      if (files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = () => {
          if (files[0].type != 'application/pdf') {
            fileError('pdfFile', 'ファイル形式が間違っています。');
          } else if (files[0].size > 20 * 1024 * 1024) {
            fileError(
              'pdfFile',
              '指定サイズ以下のファイル容量の画像ファイルを選択してください。'
            );
          } else {
            state.errorMessages.pdfFile = '';
            state.pdfFile = {
              name: files[0].name,
              data: reader.result,
              url: '',
            };
            return;
          }
        };
        return;
      } else {
        fileError('pdfFile', 'ファイルが間違っています');
      }
    };

    // --------------------------------------------------------
    //  update
    // --------------------------------------------------------
    const updateCompany = async () => {
      await axios.post(`/companies/${state.companyId}/update`, {
        info_pdf_file: state.pdfFile.data
          ? {
              name: state.pdfFile.name,
              content: state.pdfFile.data,
            }
          : null,
        items: utils.object2Array(state.inputDataCompany),
        offices: [state.inputDataHeadOffice, ...state.inputDataBranches],
      });
    };
    const publishCompany = async () => {
      await axios.post(`/companies/${state.companyId}/publish`);
    };
    const autoPublishCompany = async () => {
      await axios.post(`/companies/${state.companyId}/auto-publish`);
    };

    const update = async (action = '') => {
      if (!state.valid) {
        state.isSubmit = true;
        selectedPdfFile();
        validateCompanyLocations(true);
        const firstErrorId = document.getElementsByClassName('icj-error')[0].id;
        onScrollTo(firstErrorId);
        return;
      }

      let message = '';

      if (action === 'publish') {
        state.isSubmitted = true;
      } else {
        state.isSaving = true;
      }

      // 企業情報更新（下書き）
      await updateCompany();

      if (action === 'publish') {
        await publishCompany();
        message = '公開申請しました';
        if (state.timer) {
          clearTimeout(state.timer);
        }
        state.publishRequestedExists = 1;
      } else if (action === 'autoPublish') {
        await autoPublishCompany();
        init().then(() => {
          getCompanyDetail();
          countingRequired();
        });
        message = '企業情報を更新しました';
        if (state.timer) {
          clearTimeout(state.timer);
        }
        state.isSaving = false;
      } else {
        state.isSaving = false;
        message = '保存しました';
      }

      globalMethods.isToast(message, { timeout: 3000 });
    };

    // --------------------------------------------------------
    //  swiper用
    // --------------------------------------------------------
    const openModalForSwiper = () => {
      state.modalOpacity = false;
      state.showModal = true;
    };
    const closeModalForSwiper = () => {
      state.showModal = false;
      setTimeout(() => {
        state.modalOpacity = true;
      }, 1000);
    };

    // --------------------------------------------------------
    //  現在の企業情報
    // --------------------------------------------------------
    const getCompanyDetail = async () => {
      await axios
        .get(`/companies/${state.companyId}/published`)
        .then((response) => {
          state.publicData = response.data.data;
          state.publicData.dataType = 'public';
          closeModalForSwiper();
        })
        .catch((e) => {
          if (e.response.status == '404') {
            state.hasPublished = false;
          } else {
            globalMethods.updateModal(
              true,
              '通信エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          }
        });
    };

    // --------------------------------------------------------
    //  init
    // --------------------------------------------------------
    const updateTmpCompany = async () => {
      await updateCompany();
      if (state.timer) {
        clearTimeout(state.timer);
      }
      state.footerMessageFlag = true;
      setTimeout(() => {
        state.footerMessageFlag = false;
      }, 3000);
    };
    const init = async () => {
      //
      // companyの取得
      //
      let company = null;
      await axios
        .get(`/companies/${state.companyId}`)
        .then((response) => {
          state.formDataCompany = response.data.data.items;

          // group 分割
          state.formDataCompanyGroups = {
            profile: [],
            summary: [],
            management: [],
          };
          state.formDataCompany.forEach((obj) => {
            if (obj.input_group) {
              state.formDataCompanyGroups[obj.input_group].push(obj);
            }
          });

          state.publishRequestedExists =
            response.data.data.publish_requested_exists;
          state.is_credit_tdb = response.data.data.is_credit_tdb;
          state.is_credit_tsr = response.data.data.is_credit_tsr;
          state.is_credit_rm = response.data.data.is_credit_rm;

          if (response.data.data.drafted) {
            // 下書きデータ
            company = response.data.data.drafted;
            state.status = 'drafted';
          } else if (response.data.data.published) {
            // 公開データ
            company = response.data.data.published;
            state.status = 'published';
          }
          if (response.data.data.published) {
            state.hasPublished = true;
          } else {
            state.hasPublished = false;
          }

          if (company) {
            state.pdfFile.url = company.info_pdf_file;
            state.pdfFile.data = '';
            state.inputDataCompany = {
              ...utils.array2Object(state.formDataCompany),
              ...utils.array2Object(company.items),
            };

            // 企業所在地
            state.inputDataBranches = [];
            company.offices.forEach((office) => {
              if (office.type == 'head') {
                state.inputDataHeadOffice = office;
              } else {
                state.inputDataBranches.push(office);
              }
            });
            state.branchCount = state.inputDataBranches.length;
          }
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });

      //
      // tmpデータの取得
      // @Note: 下書き仕様が変更になったため、基本的に使わない機能だが、過去にJSON保存していたデータも存在するため、処理は必要。
      //
      if (!company) {
        // 企業
        await axios
          .get(`/companies/${state.companyId}/tmps`)
          .then((response) => {
            if (response.data.data[0]) {
              const tmpData = response.data.data[0];

              state.inputDataHeadOffice = tmpData.inputDataHeadOffice;
              state.inputDataBranches = tmpData.inputDataBranches;
              state.branchCount = state.inputDataBranches.length;

              delete tmpData.inputDataHeadOffice;
              delete tmpData.inputDataBranches;

              if (tmpData.pdfFile) {
                state.pdfFile = tmpData.pdfFile;
                delete tmpData.pdfFile;
              }

              state.inputDataCompany = tmpData;
            }
          })
          .catch((e) => {
            globalMethods.updateModal(
              true,
              'エラーが発生しました。',
              e.systemMessage || '',
              e.callback
            );
            globalMethods.sendLog(e);
          });
      }

      //
      // 企業所在地validation
      //
      validateCompanyLocations(false);

      //
      // 一時保存
      //
      if (
        !state.hasPublished &&
        !state.publishRequestedExists &&
        !state.isDraftedDisplay
      ) {
        watch(
          () => [
            state.inputDataCompany,
            state.inputDataHeadOffice,
            state.inputDataBranches,
            state.pdfFile,
          ],
          () => {
            if (state.timer) {
              clearTimeout(state.timer);
            }
            state.timer = setTimeout(updateTmpCompany, 5000);
          },
          {
            deep: true,
            lazy: true,
          }
        );
      }
    };

    // --------------------------------------------------------
    //  必須項目関連 & valid
    // --------------------------------------------------------
    const countingRequired = () => {
      //
      // 表示非表示の実行
      //
      if (state.formDataCompany) {
        runDisplayed(state.formDataCompany, '.icj-change-display-company');
      }

      nextTick(() => {
        state.requiredCount =
          document.getElementsByClassName('icj-required').length;
        state.requiredValidCount =
          document.getElementsByClassName('icj-required-valid').length;
        state.valid = document.getElementsByClassName('icj-error').length
          ? false
          : true;
      });
    };
    watch(
      () => [
        state.inputDataCompany,
        state.inputDataHeadOffice,
        state.inputDataBranches,
        state.pdfFile,
      ],
      () => {
        countingRequired();
      },
      { deep: true }
    );

    // --------------------------------------------------------
    //  previewData
    // --------------------------------------------------------
    const getPreviewData = () => {
      let prefs = {};
      for (let pref of state.prefs) {
        prefs[pref.id] = pref.name;
      }

      let previewData = {
        dataType: 'preview',
        id: state.companyId,
        name: '',
        address:
          (state.inputDataHeadOffice.prefecture
            ? prefs[state.inputDataHeadOffice.prefecture]
            : '') + (state.inputDataHeadOffice.address || ''),
        url: '',
        inquiry_url: '',
        summary_items: [],
        management_items: [],
        offices: [],
        info_images: state.publicData.info_images,
        new_pdf_file: state.pdfFile.data != '',
        is_credit_rm: state.is_credit_rm,
        is_credit_tdb: state.is_credit_tdb,
        is_credit_tsr: state.is_credit_tsr,
      };

      for (let item of state.formDataCompany) {
        let key = '';
        if (
          ['profile', 'management', 'summary'].indexOf(item.input_group) >= 0
        ) {
          if (item.input_group == 'profile' || item.input_group == 'summary') {
            key = 'summary_items';
          } else if (item.input_group == 'management') {
            key = 'management_items';
          }
          if (state.inputDataCompany[item.id]) {
            let value = '';
            if (item.options.length > 0) {
              for (let option of item.options) {
                if (item.input_type == 'checkbox') {
                  if (state.inputDataCompany[item.id].indexOf(option.id) >= 0) {
                    value += value ? ' / ' + option.name : option.name;
                  }
                } else {
                  if (state.inputDataCompany[item.id] == option.id) {
                    value = option.name;
                  }
                }
              }
            } else {
              value = state.inputDataCompany[item.id];
            }
            if (item.identifier != 'url' && item.identifier != 'inquiry_url') {
              previewData[key].push({
                name: item.name,
                input_type: item.input_type,
                unit: item.unit,
                display_format_type: item.data_type,
                values: [
                  {
                    value: value,
                  },
                ],
              });
            }
          }
        }

        if (item.identifier) {
          previewData[item.identifier] = state.inputDataCompany[item.id];
        }
      }

      previewData.offices.push({
        type: 'head',
        address:
          (state.inputDataHeadOffice.prefecture
            ? prefs[state.inputDataHeadOffice.prefecture]
            : '') + (state.inputDataHeadOffice.address || ''),
      });
      for (let item of state.inputDataBranches) {
        previewData.offices.push({
          type: 'branch',
          address:
            (item.prefecture ? prefs[item.prefecture] : '') +
            (item.address || ''),
        });
      }

      return previewData;
    };

    // --------------------------------------------------------
    //  onMounted
    // --------------------------------------------------------
    onMounted(async () => {
      await axios
        .get('/sellers')
        .then((response) => {
          state.isDraftedDisplay = response.data.data[0].is_drafted_display;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });

      state.companyId = route.params.companyId;

      openModalForSwiper();

      //
      // 都道府県情報
      //
      areas.forEach((area) => {
        area.prefs.forEach((pref) => {
          state.prefs.push(pref);
        });
      });

      init().then(() => {
        //
        // 現在の企業情報
        //
        if (state.hasPublished) {
          getCompanyDetail();
        } else {
          closeModalForSwiper();
        }

        countingRequired();
      });
    });

    // --------------------------------------------------------
    //  validation
    // --------------------------------------------------------
    const validate = (name, value, rules = 'required', message = true) => {
      const result = validateRules.validate(value, rules);
      if (result === true) {
        state.error[name] = false;
        if (message) {
          state.errorMessages[name] = '';
        }
      } else {
        state.error[name] = true;
        if (message) {
          state.errorMessages[name] = result;
        }
      }
    };
    const validateCompanyLocations = (displayMessageFlag) => {
      validate(
        'inputDataHeadOfficeZipCode',
        state.inputDataHeadOffice.zip_code,
        'required|zip',
        displayMessageFlag
      );
      validate(
        'inputDataHeadOfficePrefecture',
        state.inputDataHeadOffice.prefecture,
        'required',
        displayMessageFlag
      );
      validate(
        'inputDataHeadOfficeAddress',
        state.inputDataHeadOffice.address,
        'required',
        displayMessageFlag
      );
      for (let i = 0; i < state.inputDataBranches.length; i++) {
        validate(
          'inputDataBranchZipCode' + i,
          state.inputDataBranches[i].zip_code,
          'required|zip',
          displayMessageFlag
        );
        validate(
          'inputDataBranchPrefecture' + i,
          state.inputDataBranches[i].prefecture,
          'required',
          displayMessageFlag
        );
        validate(
          'inputDataBranchAddress' + i,
          state.inputDataBranches[i].address,
          'required',
          displayMessageFlag
        );
      }
      countingRequired();
    };
    const inputValidate = (event, rules = 'required') => {
      validate(event.target.name, event.target.value, rules);
      countingRequired();
    };

    function onScrollTo(id) {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }

    const mouseOverAction = () => {
      state.hoverShow = true;
    };
    const mouseLeaveAction = () => {
      state.hoverShow = false;
    };

    return {
      ...toRefs(state),
      addInputDataBranch,
      deleteInputDataBranch,
      deleteInputDataImage,
      changeBranchCount,
      selectedPdfFile,
      update,
      inputValidate,
      notShows,

      onScrollTo,
      getPreviewData,

      mouseOverAction,
      mouseLeaveAction,
    };
  },
};
</script>
<style lang="scss" scoped>
.ic-text-red {
  color: #de2d2d;
}
.ic-bg-red {
  background: #de2d2d;
}
.ic-border-bottom-red {
  border-bottom: #de2d2d 1px solid;
}
.fade-in-out-enter-active {
  animation: fade-in-out 0.5s;
}
.fade-in-out-leave-active {
  animation: fade-in-out 0.5s reverse;
}
@keyframes fade-in-out {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

<style lang="scss" scoped>
.isNotDisabled {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:hover::before {
    @apply border border-gray-92;
    box-shadow: 0px 0px 0px 2px rgba(52, 68, 100, 0.1);
  }
  &:checked::before {
    background: #28395c;
    border: 1px solid #28395c;
  }
  &:checked::after {
    opacity: 1;
  }
}

.isDisabled {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border: 1px solid transparent;
  border-radius: 3px;
  height: 14px;
  &::before {
    position: absolute;
    background: #fff;
    content: '';
    display: block;
    width: 16px;
    height: 16px;
    @apply border;
    border-radius: 3px;
  }
  &::after {
    position: absolute;
    top: 2px;
    left: 6px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    content: '';
    display: block;
    width: 5px;
    height: 9px;
    opacity: 0;
    transform: rotate(48deg);
  }
  &:checked::before {
    background: #f8f9fc;
    @apply border;
  }
  &:checked::after {
    opacity: 1;
  }
}

.errorDiv {
  position: absolute;
  top: -56px;
  left: 0;
}
.bg-disabled {
  background-color: #f5f6f8;
}
</style>
